import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ApiService } from '../../services/api.service';

import { CommonModule } from '@angular/common';
import { TableGuruComponent } from '../../components/table-guru/table-guru.component';

import { NgTerminalModule, FunctionsUsingCSI, NgTerminal } from 'ng-terminal';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    TableGuruComponent,
    NgTerminalModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  public user: any = null;

  public options = {

  };

  @ViewChild('terminal', { static: true }) terminal: any;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
  ) {
    this.getUser();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.terminal.setXtermOptions({
      fontFamily: 'monospace',
      cursorBlink: true
    });
  }

  private initializeTerminal() {
    const terminal = this.terminal.underlying;

    const self = this;

    const logo = `                                                                    
 ++++++  +++   ++++++++++     +++++++            ====          
 ++++++  +++   ++++++++++    ++++  ++++         ====           
 +++ ++  +++   +++          +++     ++++       ====            
 +++ +++ +++   ++++++++++   +++      +++      ====             
 +++ +++ +++   ++++++++++   +++      +++     ====              
 +++ +++ +++   +++          +++     ++++    ====               
 +++  ++ +++   ++++++++++    ++++  ++++    ====                
 +++  ++++++   ++++++++++     +++++++     ====                 
  `;

    let currentLine = 0;
    const lines = logo.split('\n');

    function animateLogo() {
      if (currentLine < lines.length) {
        terminal.writeln('\x1b[32m' + lines[currentLine++] + '\x1b[0m');
        setTimeout(animateLogo, 100); // Delay for animation
      } else {
        const currentDate = new Date().toLocaleString();

        // Stats box with dynamic width
        const statsData = [
          `NEO Office is jouw centrale plek voor alles rondom NEO.`,
          ``,
          `Datum: ${currentDate}`,
          `Totale scholen: 52`,
          `Producten: 12`,
        ];

        const boxWidth = Math.max(...statsData.map((line) => line.length)) + 15;
        const horizontalBorder = '─'.repeat(boxWidth - 2);

        const statsBox = `
┌${horizontalBorder}┐
│${` Welkom, ${self.user.name}`.padStart((boxWidth - ` Welkom, ${self.user.name}`.length) / 2).padEnd(boxWidth - 2)}│
├${horizontalBorder}┤
${statsData.map((line) => `│ ${line.padEnd(boxWidth - 4)} │`).join('\n')}
└${horizontalBorder}┘
`;

        function renderPieChart(data: { label: string; value: number }[]) {
          const total = data.reduce((sum, d) => sum + d.value, 0);
          terminal.writeln('\n');
          data.forEach((item) => {
            const percentage = Math.round((item.value / total) * 100);
            const pieSlice = '●'.repeat(Math.floor((percentage / 100) * 20)); // Scale to 20 characters
            terminal.writeln(`${item.label.padEnd(10)} | ${pieSlice} ${percentage}%`);
          });
        }

        terminal.reset();

        // Display logo
        logo.split('\n').forEach((line) => terminal.writeln('\x1b[32m' + line + '\x1b[0m'));

        // Display stats
        statsBox.split('\n').forEach((line) => terminal.writeln('\x1b[32m' + line + '\x1b[0m'));

        // Final message
        terminal.writeln('\nTyp "help" om de beschikbare commando\'s te zien.');

        terminal.write('\x1b[0m');  // Reset the terminal
        terminal.focus();  // Focus on terminal input

        let inputText = "";  // Variable to store the input text

        const themes = {
          dark: { background: '#000000', color: '#00FF00' },
          light: { background: '#FFFFFF', color: '#000000' },
          retro: { background: '#1B1B1B', color: '#FF5733' },
        };

        const commands: any = {
          help: () => terminal.writeln('\nBeschikbare commando\'s: help, stats, products, clear'),
          stats: () => statsBox.split('\n').forEach((line) => terminal.writeln('\x1b[32m' + line + '\x1b[0m')),
          products: ( () => renderPieChart([
            { label: 'A', value: 50 },
            { label: 'B', value: 30 },
            { label: 'C', value: 20 },
          ])),
          clear: () => terminal.reset(),
        };

        

        // Listen for user input
        terminal.onData(function (data: any) {
          // Handle backspace (ASCII code 127 or 8)
          if (data === '\x7f' || data === '\x08') {
            // Remove the last character from the inputText
            inputText = inputText.slice(0, -1);
            // Erase the last character from the terminal (moving back one space)
            terminal.write('\b \b');  // Move cursor back, overwrite with space, and move cursor back again
          } else if (data === '\r' || data === '\n') {
            const command = inputText.trim();
            if (commands[command]) {
              commands[command](); // Execute command
            } else {
              terminal.writeln(`\nCommando '${command}' niet gevonden.`);
            }

            inputText = '';
            terminal.write('\r\n$ ');
          } else {
            // Append the character to the inputText
            inputText += data;
            // Echo the character to the terminal
            terminal.write(data);
          }
        });
      }
    }

    animateLogo();

  }


  async getUser() {
    let self = this;
    await self.apiService.get('/me').then(function (response) {
      self.user = response;
      self.initializeTerminal();
    });
  }
}
